import React, { CSSProperties } from "react";

export default function StarCheck({
  size = 18,
  color = "black",
  style
}: {
  size?: number;
  color?: string;
  style?: CSSProperties
}) {
  return (
    <svg
      width={size + "px"}
      height={size + "px"}
      viewBox="0 0 25 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      aria-hidden={true}
    >
      <title>Icon / arrow Copy 34</title>
      <g
        id="Requirements"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Iconografia" transform="translate(-845.000000, -779.000000)">
          <g
            id="star-check-mark-copy"
            transform="translate(842.000000, 776.000000)"
          >
            <g
              id="Group"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(4.000000, 4.000000)"
              stroke={color}
              strokeWidth="1.5"
            >
              <path
                d="M7.44478391,20.003944 L4.27496945,20.003944 C3.5671592,20.003944 2.99350072,19.4302855 2.99350072,18.7224753 L2.99350072,15.5513832 C2.99350072,15.2115321 2.85807133,14.8857349 2.61787579,14.6455394 L0.375624931,12.4032885 C-0.12520831,11.9024553 -0.12520831,11.0911565 0.375624931,10.5916009 L2.64087324,8.32635263 C2.86701478,8.10021109 2.99350072,7.79485613 2.99350072,7.47544717 L2.99350072,4.27496945 C2.99350072,3.5671592 3.5671592,2.99350072 4.27496945,2.99350072 L7.44606155,2.99350072 C7.78591268,2.99350072 8.11170981,2.85807133 8.35190534,2.61787579 L10.5941562,0.375624931 C11.0949894,-0.12520831 11.9062882,-0.12520831 12.4058438,0.375624931 L14.6480947,2.61787579 C14.8882902,2.85807133 15.2140873,2.99350072 15.5539385,2.99350072 L18.7250306,2.99350072 C19.4328408,2.99350072 20.0064993,3.5671592 20.0064993,4.27496945 L20.0064993,7.44606155 C20.0064993,7.78591268 20.1419287,8.11170981 20.3821242,8.35190534 L22.6243751,10.5941562 C23.1252083,11.0949894 23.1252083,11.9062882 22.6243751,12.4058438 L20.3821242,14.6480947 C20.1419287,14.8882902 20.0064993,15.2140873 20.0064993,15.5539385 L20.0064993,18.7250306 C20.0064993,19.4328408 19.4328408,20.0064993 18.7250306,20.0064993 L15.5539385,20.0064993 C15.2140873,20.0064993 14.8882902,20.1419287 14.6480947,20.3821242 L12.4058438,22.6243751 C11.9050106,23.1252083 11.0937118,23.1252083 10.5941562,22.6243751 L8.35190534,20.3821242 C8.11043217,20.1380958 7.78463504,20.003944 7.44478391,20.003944 Z"
                id="Path"
              ></path>
              <polyline
                id="Path"
                points="15.3316298 9.58226864 10.5404955 14.373403 7.66581491 11.4987224"
              ></polyline>
            </g>
            <polygon id="Path" points="0 0 30 0 30 30 0 30"></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
}
